import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { UseQueryOptionsWithoutQueryFn } from '~/types/util/tanstack-query'

import { useFetchPurchasedTemplates } from './useFetchPurchasedTemplates'

export const queryKeys = createQueryKeys('purchased-templates', {
  all: ({ workspaceId }: { workspaceId: MaybeRef<string> }) => ({
    queryKey: [workspaceId],
  }),
})

const getAll = ({
  useQueryOptions = {},
}: {
  useQueryOptions?: UseQueryOptionsWithoutQueryFn
} = {}) => {
  const { getAll } = useFetchPurchasedTemplates()
  const { activeWorkspaceId } = useAuth()

  return useQuery({
    ...queryKeys.all({
      workspaceId: activeWorkspaceId as MaybeRef<string>,
    }),
    queryFn: () => getAll({
      workspaceId: unref(activeWorkspaceId) ?? '',
    }),
    ...useQueryOptions,
  })
}

export const useQueryPurchasedTemplates = {
  getAll,
}
